import React from 'react';
import PropTypes from 'prop-types';

import { productPropType } from '../../../types';
import intlEquipped, { propTypes as i18nPropTypes } from '../../../hocs/intlEquipped';

import InlineSection from '../../InlineSection/InlineSection';

const ProductItem = ({ product, number, theme, i18n }) => {
    const { formatPrice, formatMessage } = i18n;

    return (
        <div className={ theme.productItem }>
            <div className={ theme.number }>{ number }</div>
            <div className={ theme.items }>
                <InlineSection
                    theme={ theme }
                    mainContent={ <span>{ product.productName }</span> }
                    subContent={ <span>{ formatPrice(product.chargeAmount) }</span> }
                    className={ theme.price }
                />
                <InlineSection
                    theme={ theme }
                    mainContent={ <span>{ formatMessage('products.item.vat') }</span> }
                    subContent={ <span>{ formatPrice(product.taxAmount) }</span> }
                    className={ theme.vat }
                />
            </div>
        </div>
    );
};

ProductItem.propTypes = {
    product: productPropType,
    theme: PropTypes.shape({}),
    number: PropTypes.number.isRequired,
    i18n: i18nPropTypes,
};

export default intlEquipped(ProductItem);
